import type { ApplicationConfigurationCustomQuestion } from '@zg-rentals/ts-capps-client';
import { useApplicationContext } from '../contexts/ApplicationContext';
import { getIsCustomQuestionEnabled } from '../utils/customQuestions';

export function useIsCustomQuestionEnabled(question: ApplicationConfigurationCustomQuestion) {
  const { application } = useApplicationContext();
  return getIsCustomQuestionEnabled(application.answers, question);
}
